import { $WC, $DKD } from '@/conf/common.const.js';
import commonApi from "@/api/common.api.js";
import realtimeApi from "@/api/realtime.api.js";
import gripUtil from "@/lib/grip.util.js";
import naverMapUtil from "@/lib/grip.naver.map.util.js";

export default {
    state: {
        safetyList: [],
        safetyTypeMap: {},
        // 의료 시설
        medicalFacList: [],
        // 안전센터 목록
        safetyCenterList: [],
        // 경찰서 목록
        policeList: [],
        accidentList: [],
        accidentCategoryMap: {},
        // 자치구 대기 질
        airGu: {},
        // 공기질 행정동 목록
        airHjdList:[],
        // 공기질 행정동 맵
        airHjdMap: {},
        // 공기질 행정동 평균
        airHjdAvg: {},
        // 배수지
        waterReservoirList: [],
        // 수도꼭지
        waterFaucetList: [],
        // 수질 정보
        waterQualityMap: {},
        // 물길 정보
        waterRoadList: [],
        // 날씨 정보
        airSpace: {},
        // 금일 날씨 예보 정보
        // weatherForecastDay0: {},
        // 물가 정보
        priceInfo: {},
    },
    getters: {
        getSafetyList(state) {
            return state.safetyList;
        },
        getSafetyTypeMap(state) {
            return state.safetyTypeMap;
        },
        getMedicalFacList(state) {
            return state.medicalFacList;
        },
        getSafetyCenterList(state) {
            return state.safetyCenterList;
        },
        getPoliceList(state) {
            return state.policeList;
        },
        getAccidentList(state) {
            return state.accidentList;
        },
        getAccidentCategoryMap(state) {
            return state.accidentCategoryMap;
        },
        getAirGu(state) {
            return state.airGu;
        },
        getAirHjdList(state) {
            return state.airHjdList;
        },
        getAirHjdMap(state) {
            return state.airHjdMap;
        },
        getAirHjdAvg(state) {
            return state.airHjdAvg;
        },
        getWaterReservoirList(state) {
            return state.waterReservoirList;
        },
        getWaterFaucetList(state) {
            return state.waterFaucetList;
        },
        getWaterQualityMap(state) {
            return state.waterQualityMap;
        },
        getWaterRoadList(state) {
            return state.waterRoadList;
        },
        getAirSpace(state) {
            return state.airSpace;
        },
        // getWeatherForecastDay0(state) {
        //     return state.weatherForecastDay0;
        // },
        getPriceInfo(state) {
            return  state.priceInfo;
        },
    },
    mutations: {
        SAFETY_LIST(state, safetyList) {
            state.safetyList = safetyList;
        },
        SAFETY_TYPE_MAP(state, safetyTypeMap) {
            state.safetyTypeMap = safetyTypeMap;
        },
        MEDICALFAC_LIST(state, medicalFacList) {
            state.medicalFacList = medicalFacList;
        },
        SAFETYCENTER_LIST(state, safetyCenterList) {
            state.safetyCenterList = safetyCenterList;
        },
        POLICE_LIST(state, policeList) {
            state.policeList = policeList;
        },
        ACCIDENT_LIST(state, accidentList) {
            state.accidentList = accidentList;
        },
        ACCIDENT_CATEGORY_MAP(state, accidentCategoryMap) {
            state.accidentCategoryMap = accidentCategoryMap;
        },
        AIR_GU(state, airGu) {
            state.airGu = airGu;
        },
        AIR_HJD_LIST(state, airHjdList) {
            state.airHjdList = airHjdList;
        },
        AIR_HJD_MAP(state, airHjdMap) {
            state.airHjdMap = airHjdMap;
        },
        AIR_HJD_AVG(state, airHjdAvg) {
            state.airHjdAvg = airHjdAvg;
        },
        WATER_RESERVOIR_LIST(state, waterReservoirList) {
            state.waterReservoirList = waterReservoirList;
        },
        WATER_FAUCET_LIST(state, waterFaucetList) {
            state.waterFaucetList = waterFaucetList;
        },
        WATER_QUAILTY_MAP(state, waterQualityMap) {
            state.waterQualityMap = waterQualityMap;
        },
        WATER_ROAD_LIST(state, waterRoadList) {
            state.waterRoadList = waterRoadList;
        },
        AIRSPACE(state, airSpace) {
            state.airSpace = airSpace;
        },
        // WEATHER_FORECAST_DAY0(state, weatherForecastDay0) {
        //     state.weatherForecastDay0 = weatherForecastDay0;
        // },
        PRICE_INFO(state, priceInfo) {
            state.priceInfo = priceInfo;
        },
    },
    actions: {
        FETCH_SAFETY_LIST({commit}) {
            // let curTime = new Date().format("yyyyMMddHHmmss");
            let q = "stateMode=1";
            return realtimeApi.fetchSafetyList(q)
                .then(res => {
                    // 재난과 화재만
                    let safetyList = res.data.data.filter(safety => {
                        return safety['safetyCategoryCd'] === '0' || safety['safetyCategoryCd'] === '1';
                    });

                    commit("SAFETY_LIST", safetyList);
                    commit("SAFETY_TYPE_MAP", gripUtil.toMap(safetyList, "safetyCategoryCd"));
                });
        },
        FETCH_MEDICALFAC_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.MEDICALFAC)
                .then(res => {
                    commit("MEDICALFAC_LIST", res.data.data);
                });
        },
        FETCH_SAFETYCENTER_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.SAFETYCENTER)
                .then(res => {
                    commit("SAFETYCENTER_LIST", res.data.data);
                });
        },
        FETCH_POLICE_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.POLICE)
                .then(res => {
                    commit("POLICE_LIST", res.data.data);
                });
        },
        FETCH_ACCIDENT_LIST({commit}) {
            return realtimeApi.fetchAccidentList(1)
                .then(res => {
                    let accidentList = res.data.data;
                    accidentList = accidentList.filter(accident => {
                        accident.wtmX = accident.lgtdVal;
                        accident.wtmY = accident.lttdVal;

                        if(accident.wtmX && accident.wtmY) {
                            return realtimeApi.configAccidentCategory(accident);
                        } else {
                            return false;
                        }
                    });

                    let applyAccidentList = [];
                    let proms = [];
                    accidentList.forEach(accident => {
                        let latlng = naverMapUtil.convertWgs84Coords(accident.wtmY, accident.wtmX);
                        accident.lttdVal = latlng[0];
                        accident.lgtdVal = latlng[1];

                        let prom = naverMapUtil.searchCoordinateToAddress(naver.maps.LatLng(accident.lttdVal, accident.lgtdVal))
                            .then(addr => {
                                if(typeof addr[0] !== $WC.UNDEF) {
                                    if(addr[0].region.area2.name === $WC.localGovName) {
                                        accident.guNm = addr[0].region.area2.name;
                                        accident.dongNm = addr[0].region.area3.name;
                                        applyAccidentList.push(accident);
                                    }
                                }
                            });
                        proms.push(prom);
                    });

                    return Promise.all(proms).then(() => {
                        commit('ACCIDENT_LIST', applyAccidentList);
                        commit('ACCIDENT_CATEGORY_MAP', gripUtil.toMap(applyAccidentList, 'accidentCategoryCd'));
                    });
                });
        },
        FETCH_AIR_GU({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.AIR_GU)
                .then(res => {
                    let airGu = {};
                    if(res.data.statusCode === 200 && res.data.totalCount > 0) {
                        airGu = res.data.data[0];
                    }
                    commit('AIR_GU', airGu);
                });
        },
        FETCH_AIR_HJD_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.AIR_HJD)
                .then(res => {
                    let airHjdList = res.data.data;
                    let sum = {pm10: 0, pm25: 0, no2: 0, o3: 0};
                    let avg = {pm10: '-', pm25: '-', no2: '-', o3: '-'};

                    if(typeof airHjdList !== $WC.UNDEF) {
                        airHjdList.forEach(air => {
                            sum.pm10 += Number(air['val8']);
                            sum.pm25 += Number(air['val10']);
                            sum.no2 += Number(air['val14']);
                            sum.o3 += Number(air['val12']);
                        });

                        let hjdLen = airHjdList.length;
                        avg = {
                            pm10: (sum.pm10 / hjdLen).toFixed(0),
                            pm25: (sum.pm25 / hjdLen).toFixed(0),
                            no2: (sum.no2 / hjdLen).toFixed(2),
                            o3: (sum.o3 / hjdLen).toFixed(3),
                        };
                    }

                    commit('AIR_HJD_LIST', airHjdList);
                    commit('AIR_HJD_MAP', gripUtil.toDict(airHjdList, 'val3'));
                    commit('AIR_HJD_AVG', avg);
                });
        },
        FETCH_WATER_RESERVOIR_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.WATER_RESERVOIR)
                .then(res => {
                    commit("WATER_RESERVOIR_LIST", res.data.data);
                });
        },
        FETCH_WATER_FAUCET_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.WATER_FAUCET)
                .then(res => {
                    commit("WATER_FAUCET_LIST", res.data.data);
                });
        },
        FETCH_LASTEST_WATER_QUALITY_LIST({commit}) {
            return realtimeApi.fetchLatestWaterQualityList()
                .then(res => {
                    let waterQualityList = res.data.data;
                    if(typeof waterQualityList  !== $WC.UNDEF) {
                        waterQualityList = waterQualityList.filter(waterQuality => {
                            return (typeof waterQuality.facNm !== $WC.UNDEF &&
                                    waterQuality.facNm != null &&
                                    waterQuality.facNm.trim() !== '' &&
                                    waterQuality.facNm.trim() !== 'null');
                        });
                    }
                    commit('WATER_QUAILTY_MAP', gripUtil.toDict(waterQualityList, 'facNm'));
                });
        },
        FETCH_WATER_ROAD_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.WATER_ROAD)
                .then(res => {
                    commit("WATER_ROAD_LIST", res.data.data);
                });
        },
        FETCH_AIRSPACE({commit}) {
            return realtimeApi.fetchAirSpace()
                .then(res => {
                    commit('AIRSPACE', res.data.data);
                });
        },
        /*
        FETCH_WEATHER_FORECAST_DAY0({commit}) {
            let date = new Date();
            let hhmm = date.format('HH') + "00";

            console.log(hhmm);
            date.setDate(date.getDate());
            let day = date.format('yyyyMMdd');

            return realtimeApi.fetchWeatherForecast('20200730', hhmm)
                .then(res => {
                    console.log(res.data.data);
                });
        },
        */
        FETCH_PRICE_INFO({commit}) {
            return realtimeApi.fetchPriceInfo()
                .then(res => {
                    commit('PRICE_INFO', res.data.data);
                });
        },
    }
};
